export default "__VITE_ASSET__Cp6uMCun__"